import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
const Footer = () => (
  <footer className="site-footer">
    <div className="site-container footer-inner">
      <span>© 2026 Adam Adha Kamarul Zaman</span>
      <div className="socials">
        <a
          href="https://www.linkedin.com/in/adamadha3/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
        >
          <FaLinkedin />
        </a>
        <a
          href="https://github.com/adamadha8"
          target="_blank"
          rel="noreferrer"
          aria-label="GitHub"
        >
          <FaGithub />
        </a>
      </div>
    </div>
  </footer>
);
export default Footer;
